import React from 'react';
import styled from 'styled-components';
import useError from '../../../hooks/useError';
import useTranslate from '../../../hooks/useTranslate';
import Button from '../Button';

const ErrorMessage = () => {
  const { isNetworkError, errorMessage, reload } = useError();
  const { t } = useTranslate();

  if (isNetworkError) {
    return (
      <Wrapper>
        {t('lostConnection')}
        <ButtonWrapper>
          <Button onClick={reload}>{t('reloadPage')}</Button>
        </ButtonWrapper>
      </Wrapper>
    );
  }

  return <Wrapper>{errorMessage}</Wrapper>;
};

export default ErrorMessage;

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
  padding: 0 16px;
  font-size: 1.5rem;
  z-index: 10;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  max-width: 250px;
  margin: 10px auto;
`;
